<template>
    <Card class="CompanyLatestTickets">
        <h2>Latest tickets</h2>

        <div class="item" v-for="ticket in tickets" :key="ticket.id">
            <div class="main">
                <h4>{{ ticket.project.name }}</h4>
                <span>Created {{ ticket.createdAt | formatDateDistance }} by {{ `${ticket.user.firstName} ${ticket.user.lastName}` }}</span>
            </div>

            <Dropdown>
                <template #trigger>
                    <Button class="link">More &#9660;</Button>
                </template>
                <template #menu>
                    <router-link :to="`/company/tickets/${ticket.id}/edit`">Edit</router-link>
                    <router-link :to="`/company/reports/view?type=hauling&ticket=${ticket.ticketNumber}`">Generate Report</router-link>
                </template>
            </Dropdown>
        </div>
    </Card>
</template>

<script>
import Card from '@/components/Card';
import Dropdown from '@/components/Dropdown';

export default {
    name: 'CompanyLatestTickets',

    components: { Card, Dropdown },

    props: {
        tickets: { type: Array, required: true },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CompanyLatestTickets {
    padding: $grid-gutter-width;

    h2 {
        margin-bottom: 20px;
        font-weight: $font-weight-regular;
    }

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: $grid-gutter-width;

        span, a {
            font-size: 14px;
        }

        a {
            font-weight: $font-weight-bold;
        }
    }

    .Button {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
